import { createTheme } from '@mui/material/styles';
import themeData from './../../../assets/Dark.theme.json';
export const DarkTheme = createTheme(themeData);
export default DarkTheme;
